// Libraries
import { useEffect, useRef, useState } from 'react';
import { WebRTCAdaptor } from '@antmedia/webrtc_adaptor';

// Hooks
import { useAppSelector } from '../../../app/hooks';

// Features
import {
    selectCurrentGame,
    selectSession,
} from '../../../features/session/sessionSlice';

// Styles
import styles from './VideoStream.module.css';

/**
 * @function WebRTCAdaptorInit
 */
const webRTCAdaptor = (() => {
    let instance: any;

    function createInstance() {
        return new WebRTCAdaptor({
            websocket_url: 'wss://ant.bingoport.com:5443/WebRTCAppEE/websocket',
            mediaConstraints: {
                video: false,
                audio: false,
            },
            peerconnection_config: {
                iceServers: [{ urls: 'stun:stun1.l.google.com:19302' }],
            },
            sdp_constraints: {
                OfferToReceiveAudio: true,
                OfferToReceiveVideo: true,
            },
            isPlayMode: true,
            bandwidth: 500, // default is 900 kbps, string can be 'unlimited'
            dataChannelEnabled: true, // enable or disable data channel
            callback: (info: any, obj: object) => {
                if (info == 'initialized') {
                    console.log('initialized');
                }
            },
            callbackError: function (error: any, message: string) {},
        });
    }

    return {
        getInstance: function () {
            if (!instance) {
                instance = createInstance();
            }
            return instance;
        },
    };
})();

/**
 * @function VideoStream
 * Live video stream feed
 *
 * @example
 * return (
 *   <VideoStream boolean={true} />
 * )
 */
function VideoStream(): JSX.Element {
    const [visible, setVisible] = useState<boolean>(false);
    const session = useAppSelector(selectSession);
    const game = useAppSelector(selectCurrentGame);
    const ref = useRef<HTMLVideoElement>(null);

    // On component render, intialise livestream connection
    useEffect(() => {
        const webRTCInstance = webRTCAdaptor.getInstance();
        const streamId = session !== null ? 'stream_' + session.id : 'stream1';

        if (ref.current) {
            webRTCInstance.remoteVideo = ref.current;

            setTimeout(() => {
                webRTCInstance.play(streamId);
            }, 2000);
        }

        // On component unmount, close livestream connection
        return () => {
            webRTCInstance.closeWebSocket(streamId);
        };
    }, []);

    // On game state change, update visibility
    useEffect(() => {
        if (game.state === 'open') {
            setVisible(() => true);
        } else {
            setVisible(() => false);
        }
    }, [game.state]);

    return (
        <aside
            className={`${styles.container}${
                visible === true ? ` ${styles.visible}` : ''
            }`}
        >
            <div className={styles.video}>
                <video
                    id="VideoContainer"
                    autoPlay
                    playsInline
                    ref={ref}
                ></video>
            </div>
            {/* <p className={styles.caption}>Call no. {number}</p> */}
        </aside>
    );
}

// Exports
export default VideoStream;
